import React from "react";

const ADO_Delete = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Delete</h1>
      <p>This is the ADO Delete page content.</p>
    </div>
  );
};

export default ADO_Delete;
